import React from "react";
import { Link } from "react-router-dom";
import Logo from '../components/Logo.js'
import Button from "./Button.js";

const Navbar = () => {
  return (
    <header className="bg-white shadow py-4">
      <nav className="container mx-auto px-4">
        <div className="flex items-center justify-around">
          <div className="flex items-center">
            <Logo />

            <ul className="ml-10 flex items-stretch gap-5">
              <li>
                <Link to={"/"} className="hover:text-primary text-primary">
                  Home
                </Link>
              </li>
              <li>
                <div className="flex items-center gap-1 cursor-pointer hover:text-primary">
                  <span>Doctor</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-3 h-3"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </li>
              <li className="cursor-pointer hover:text-primary">Patiens</li>
              <li className="cursor-pointer hover:text-primary">Pages</li>
              <li className="cursor-pointer hover:text-primary">Blog</li>
              <li className="cursor-pointer hover:text-primary">Admin</li>
            </ul>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="/"
              className="inline-block bg-primary rounded-full p-2 ring-1 ring-primary hover:bg-cyan-300 hover:ring-cyan-300 transition duration-100"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-6 h-6 text-white p-0.5"
              >
                <path
                  fillRule="evenodd"
                  d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z"
                  clipRule="evenodd"
                />
              </svg>
            </a>

            <Button title={'Login'} />
            <Button title={'Sign Up'} btnOutline />
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
